import { GETADMIN, GETCUSTOMER } from "@/graphql/AccountQueries.js";
import { runGqlQuery } from "@/graphql/gqlUtil.js";

const state = () => ({
  userInfo: {
    _id: "",
    ID: "",
    Permission: 0,
    Cashier_ID: "",
  },
  customerList: [],
  customerOne: {
    custNum: "",
    firstName: "",
    lastName: "",
    company: "",
    phone: "",
    Address_1: "",
    Address_2: "",
    City: "",
    Zip_Code: "",
    address: "",
  },
  customerPages: 0,
  employeeList: [],
  employeeOne: {
    _id: "",
    ID: "",
    Email: "",
    Permission: 0,
  },
  employeePages: 0,
});

const actions = {
  async getCustomerList({ commit }, payload) {
    try {
      const customerResult = await runGqlQuery(GETCUSTOMER, payload);
      if (customerResult.message === undefined) {
        await commit("setCustomerList", {
          getCustomers: customerResult.getCustomers,
        });
        if (customerResult.getCustomers.length === 0) {
          return "no data";
        }
      } else {
        return "no data";
      }
    } catch (err) {
      console.log("getCustomerList: " + err);
    }
  },
  async getCustomerListForAdd({ commit }, payload) {
    try {
      const customerResult = await runGqlQuery(GETCUSTOMER, payload);
      return customerResult;
    } catch (err) {
      console.log("getCustomerList: " + err);
    }
  },
  async getCustomerOne({ commit }, payload) {
    try {
      const customerResult = await runGqlQuery(GETCUSTOMER, {
        Column: "CustNum",
        Search: payload.Search,
      });
      if (customerResult.message === undefined) {
        await commit("setCustomerOne", customerResult.getCustomers[0]);
      } else {
        commit(
          "common/snackErrOn",
          { text: "There is no customer infomation!" },
          { root: true }
        );
        return "no data";
      }
    } catch (err) {
      console.log("getCustomerOne: " + err);
    }
  },
  async getEmployeeList({ commit }, payload) {
    try {
      const employeeResult = await runGqlQuery(GETADMIN, {
        Column: payload.Column,
        Search: payload.Search,
        Page_No: payload.Page_No,
        Page_Size: payload.Page_Size,
      });
      if (employeeResult.message === undefined) {
        await commit(
          "account/setEmployeeList",
          { getEmployeeList: employeeResult.getAdmins },
          { root: true }
        );

        if (employeeResult.getAdmins.length === 0) {
          return "no data";
        }
      } else {
        return "no data";
      }
    } catch (err) {
      console.log("getEmployeeList: " + err);
    }
  },
  async getAdminIdForDuplicate({ commit }, payload) {
    try {
      let dup = false;
      const getResult = await runGqlQuery(GETADMIN, {
        Column: payload.Column,
        Search: payload.Search,
      });

      if (getResult.getAdmins.length !== 0) {
        getResult.getAdmins.forEach((data) => {
          if (data.ID === payload.Search) {
            dup = true;
          }
        });
      }
      return dup;
    } catch (err) {
      console.log("getAdminIdForDuplicate: " + err);
    }
  },
  async getAdminEmailForDuplicate({ commit, state }, payload) {
    try {
      let dup = false;
      const getResult = await runGqlQuery(GETADMIN, {
        Column: payload.Column,
        Search: payload.Search,
      });
      if (getResult.getAdmins.length != 0) {
        getResult.getAdmins.forEach((data) => {
          if (
            data.Email == payload.Search &&
            data.Email != state.employeeOne.Email
          ) {
            dup = true;
          }
        });
      }
      return dup;
    } catch (err) {
      console.log("getAdminEmailForDuplicate: " + err);
    }
  },
};

const mutations = {
  setUser(state, payload) {
    try {
      state.userInfo._id = payload._id;
      state.userInfo.ID = payload.ID;
      state.userInfo.Permission = payload.Permission;
      state.userInfo.Cashier_ID = payload.Cashier_ID;
    } catch (err) {
      console.log("setUser: " + err);
    }
  },
  async setCustomerList(state, payload) {
    try {
      const temp = payload.getCustomers;
      const newArray = [];

      temp.map((data) => {
        const listOne = {};
        listOne.CustNum = data.CustNum;
        listOne.Company = data.Company;
        listOne.First_Name = data.First_Name;
        listOne.Last_Name = data.Last_Name;
        const phone = data.Phone_1 || "" || data.Phone_2 || "" || "";
        if (phone !== "") listOne.Phone = phone;
        listOne.address =
          (data.Address_1 || "") +
          " " +
          (data.Address_2 || "") +
          " " +
          (data.City || "") +
          " " +
          (data.Zip_Code || "");
        newArray.push(listOne);
      });
      state.customerList = newArray;
    } catch (err) {
      console.log("setCustomerList: " + err);
    }
  },
  setCustomerOne(state, payload) {
    try {
      const temp = payload;
      const tempObject = {};

      tempObject.custNum = temp.CustNum || "";
      tempObject.firstName = temp.First_Name || "";
      tempObject.lastName = temp.Last_Name || "";
      tempObject.company = temp.Company || "";
      tempObject.phone = temp.Phone_1 || "" || temp.Phone_2 || "" || "";
      tempObject.Address_1 = temp.Address_1 || "";
      tempObject.Address_2 = temp.Address_2 || "";
      tempObject.City = temp.City || "";
      tempObject.Zip_Code = temp.Zip_Code || "";
      tempObject.address =
        (temp.Address_1 || "") +
        " " +
        (temp.Address_2 || "") +
        " " +
        (temp.City || "") +
        " " +
        (temp.Zip_Code || "");

      state.customerOne = tempObject;
    } catch (err) {
      console.log("setCustomerOne: " + err);
    }
  },
  setEmployeeList(state, payload) {
    try {
      const temp = payload.getEmployeeList;
      const newArray = [];
      state.employeeList = {};

      temp.map((data) => {
        const employeeOne = {};
        employeeOne._id = data._id;
        employeeOne.Cashier_ID = data.Cashier_ID;
        employeeOne.First_Name = data.First_Name || "";
        employeeOne.Last_Name = data.Last_Name || "";
        employeeOne.Id = data.ID;
        employeeOne.Email = data.Email;
        newArray.push(employeeOne);
      });

      state.employeeList = newArray;
    } catch (err) {
      console.log("setEmployeeList: " + err);
    }
  },
  setEmployeeOne(state, payload) {
    try {
      const temp = payload.getEmployeeList;
      const newOne = {};

      newOne._id = temp._id;
      newOne.ID = temp.ID;
      newOne.Email = temp.Email;
      newOne.Permission = temp.Permission;
      newOne.Cashier_ID = temp.Cashier_ID;

      state.employeeOne = newOne;
    } catch (err) {
      console.log("setEmployeeOne: " + err);
    }
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
};
